
const tr = {
    ui: {
        interested: "İlgileniyorum",
        going: 'Gidiyorum',
        notNow: 'Daha Sonra',
        permitNotifications: 'Bildirimleri Aç',
        noFavoriteItems: 'Favorilerine henüz herhangi bir etkinlik eklemedin.',
        followings: 'Takip Ettiklerin',
        extraDates: '+{msg} tarih',
        thisEventIsPassed: 'Bu etkinlik sona ermiştir.',
        subscribe: 'Abone Ol',
        subscribed: 'Abone Olundu',
        loadMore: 'Daha fazla göster',
        myAccount: 'Hesabım',
        account: 'hesap',
        apply: 'uygula',
        menu: 'Menü',
        all: 'Tümü',
        agree: 'Katılıyorum',
        continue: 'Devam et',
        pay: 'Ödeme Yap',
        welcome: 'Hoş geldin',
        or: 'yada',
        payment: 'Ödeme',
        makePayment: 'Ödeme yap',
        helpAndSupport: 'Yardım & Destek',
        faq: 'S.S.S.',
        termsOfService: 'Kullanım Şartları',
        privacyPolicy: 'Gizlilik Sözleşmesi',
        allRightsReserved: 'Tüm hakları saklıdır',
        explore: 'Keşfet',
        details: 'detaylar',
        saved: 'Kaydedilen',
        step: 'adım',
        seeTicket: 'Bileti gör',
        notification: 'Bildirim',
        about: 'hakkında',
        profile: 'Profil',
        hello: 'Merhaba',
        search: 'Ara',
        back: 'geri',
        home: 'Anasayfa',
        backToHomePage: 'Anasayfaya dön',
        eventConditions: 'Etkinlik Şartları',
        share: 'paylaş',
        // aboutEventPerformer: '{msg} Hakkında',
        aboutEvent: "Etkinlik Hakkında",
        follow: 'Takip et',
        followers: 'takipçi',
        following: 'Takip ediliyor',
        seeAll: 'Tümünü Gör',
        buyTicket: 'Bilet Al',
        goToTicket: 'Bilete Git',
        total: 'Toplam',
        ticket: 'Bilet',
        ticketInfo: 'Bilet bilgisi',
        noEventWithSelectedSubTypes: "Üzgünüz, yaklaşan {msg} türü bir etkinlik bulamadık",
        ok: 'Tamam',
        toContinue: "Devam etmek için",
        serviceFeeExplanation: "Bu size verdiğimiz hizmeti sürdürmemize yardımcı oluyor.",
        studentTicketTooltip: 'Etkinlik mekanına girişte öğrenci kimliğinizi göstermeniz gerekecektir.',
        checkYourPurchaseWarning: 'Lütfen, bilet bilgileriniz kontrol edin ve etkinlik kurallarını okuduğunuzdan emin olun',
        eventInfo: "Etkinlik Bilgisi",
        customerInfo: "Müşteri Bilgisi",
        paymentInfo: 'Ödeme Bilgisi',
        phoneNumberOptional: 'Telefon numarası opsiyoneldir. Eğer bilet bilginizi SMS olarak almak istemiyorsanız bu alanı boş bırakabilirsiniz',
        cardNumber: 'Kart Numarası',
        cardExpirationDate: 'Son Kullanma Tarihi',
        whatIsCVC2: 'CVC2 nedir?',
        eventName: 'Etkinlik Adı',
        eventDate: 'Etkinlik Tarihi',
        eventLocation: 'Etkinlik Yeri',
        selectedTickets: 'Seçili Biletler',
        fullNameOnCard: 'Kart Üzerindeki İsim',
        fullNameOnCardIsNotValid: 'Kart üzerindeki isim hatalı',
        cardNumberIsNotValid: 'Kart numarası hatalı',
        cardExpDateIsNotValid: 'Son kullanma tarihi hatalı',
        cardCVC2IsNotValid: 'CVC2 numarası hatalı',
        fieldCantBeEmpty: 'Bu alan boş bırakılamaz',
        checkInfoOnField: 'Bu alandaki bilgiyi kontrol edin',
        canMakePaymentByUsingBelowCards: "Aşağıda listelenen kartlardan herhangi birini kullanarak ödeme yapabilirsiniz",
        paymentLastStepIntroInfo: "Son adımdasınız. Aşağıdaki alanlara bilgilerinizi girerek kolayca bilet alabilirsiniz",
        eventRules: 'Etkinlik Kuralları',
        reviewEventRules: 'Etkinlik kurallarını inceleyin',
        explainWhyAndHowWeUseCustomerInformation: "Bilgilerinizi size biletinzi yollamak ve etkinlik ile ilgili gelişmeleri haber vermek için kullanıyoruz.",
        explainHowCardInfoIsUsed: 'Kart bilgileriniz yalnızca ödemeyi gerçekleştirmek için kullanılır ve asla kayıt edilmez.',
        today: 'Bugün',
        tomorrow: 'Yarın',
        thisWeek: 'Bu hafta',
        thisWeekend: 'Bu hafta sonu',
        weekend: 'Hafta sonu',
        thisMonth: 'Bu ay',
        youMightBeInterested: 'İlginizi çekebilir',
        typeYouMightBeInterested: 'İlginizi çekebilecek {msg} etkinlikleri',
        festivalsInCity: '{msg} festivalleri',
        otherEventsOfVenue: ' {msg} etkinlikleri',
        // startsFrom: "{msg} ₺'den başlayan",
        more: 'daha',
        moreFrom: 'DAHA FAZLA',
        readMore: 'devamını oku',
        showtimes: 'Gösterim Tarihleri',
        selectDate: 'Tarih Seçin',
        selectTicket: 'Bilet Seçin',
        avaliableSeats: 'koltuk uygun',
        avaliableTickets: 'bilet kaldı',
        displayDates: 'Tarih Görünümü',
        displayEvents: 'Etkinlik Görünümü',
        seeEvents: 'Etkinlikleri gör',
        events: 'Etkinlikler',
        // ofEvents: 'etkinlikleri',
        event: 'etkinlik',
        venues: 'Mekanlar',
        showMap: 'Haritada Göster',
        hideMap: 'Haritayı Gizle',
        hide: 'Gizle',
        every: 'her',
        day: 'gün',
        date: 'date',
        week: 'hafta',
        month: 'ay',
        tickets: 'Biletler',
        eventVenue: "Etkinlik Mekanı",
        place: 'Yer',
        exploreEventsInYourCity: 'Şehrindeki etkinlikleri keşfet',
        venueProperties: 'Mekan Özellikleri',
        ticketProvider: 'Bilet satışı',
        eventsBySameVenue: '{msg} etkinlikleri',
        eventsByTypeNotFound: 'Üzgünüz, aradığınız türde yakın tarihli bir etkinlik bulamadık.',
        seeAllEventsOfType: 'Tüm {msg} etkinliklerini gör',
        continueToExplore: 'Keşfe dön',
        willBeRedirect: 'Bilet almak için {msg} adresine yönlendirilirsiniz.',
        cancel: 'Vazgeç',
        ofEvents: 'etkinlikleri',
        ofTickets: 'biletleri',
        upcoming: 'yaklaşan',
        upcomingEvents: 'Yaklaşan etkinlikler',
        noUpcomingEvents: 'Yaklaşan etkinlik bulunamadı.',
        exploreApp: "hafta8'i keşfet",
        featured: 'Öne çıkanlar',
        featuredEvents: 'Öne Çıkan Etkinlikler',
        recommendedVenues: 'Senin için önerilen {msg}',
        free: 'Ücretsiz',
        venueInfos: 'Mekan bilgileri',
        legalName: 'İsim soyisim',
        edit: 'Güncelle',
        filter: 'filtrele',
        filters: 'filtreler',
        clear: 'temizle',
        clearFilters: 'filtreyi sıfırla',
        type: 'tür',
        price: 'fiyat',
        // date: 'tarih',
        dateRange: 'tarih aralığı',
        priceRange: 'fiyat aralığı',
        save: 'kaydet',
        refresh: 'yenile',
        ticketsAreSoldOnDoor: 'Biletler etkinlik mekanı girişte',
        favorites: 'Favoriler',
        relatedVenues: 'Benzer mekanlar',
        searchPlaceholder: 'Etkinlikler ve Mekanlarda ara...',
        createEvent: 'Etkinlik Oluştur',
        addEvent: 'Etkinlik Ekle',
        cookieAlert: "Size en iyi deneyimi sağlayabilmek adına 'çerezler' kullanıyoruz. Bu siteyi kullanarak bunu kabul etmiş sayılırsınız.",
        iSee: 'Anladım',
    },
    venueType: {
         hotel: 'otel',
        museum: 'müze',
        charity: 'vakıf',
         exhibitionCenter: 'sergi salonu',
         artCenter: 'sanat merkezi',
         performanceHall: 'performans salonu',
         danceStudio: 'dans stüdyosu',
         theatre: 'tiyatro',
         atelier: 'atölye',
         cafe: 'kafe',
         pub: 'bar',
         generalPurposeCenter: 'çok amaçlı gösteri merkezi',

    },
    venueTypePlural: {
         hotel: 'oteller',
         exhibitionCenter: 'sergi salonları',
         artCenter: 'sanat merkezleri',
         performanceHall: 'performans salonları',
         danceStudio: 'dans stüdyoları',
         theatre: 'tiyatro salonları',
         atelier: 'atölyeler',
         cafe: 'kafeler',
         pub: 'barlar',
         generalPurposeCenter: 'çok amaçlı gösteri merkezleri',

    },
    venueProperties: {
        toilet: 'tuvalet',
        garden: 'bahçe',
        cloakroom: 'vestiyer',
        drink: 'içecek',
        food: 'yemek',
        alcohol: 'alkol',
        vale: 'vale',
        parking: 'otopark',
        smokingArea: 'sigara içilen alan',
        airConditioner: 'havalandırma',
    },
    ticket: {
        selectSeat: 'Koltuk Seçimi',
        chooseTicket: 'Bilet Seç',
        main: 'Normal Bilet',
        adult: 'Yetişkin',
        student: 'Öğrenci',
        discounted: 'İndirimli',
        youWontBeChargedYet: 'Bu adımda hesabınızdan para çekilmez',
        serviceFee: 'Hizmet Bedeli',
        startsFrom: "{msg} ₺'den başlayan",
        selectTicketBeforeContinue: 'Devam etmeden önce bilet seçin',
    },
    evType: {
        all: 'tüm',
        more: 'dahası',
        moreToCome: 'dahası yakında',
        // moreToCome: 'more to come',
        // concert
        concert: 'Konser',
        concerts: 'Konserler',
        jazz: "caz",
        rock: "rock",
        hipHop: "hip-hop",
        indie: "indie",
        pop: "pop",
        folk: 'halk müziği',
        turkishFolk: 'türkü',
        popRock: "pop-rock",
        ethnic: 'etnik',
        dj: 'dj',
        choir: 'koro',
        alternative: "alternatif",
        metal: "metal",
        electronic: 'elektronik',
        symphony: "senfoni",
        classical: "klasik",
        concerto: 'concerto',
        rap: "rap",
        recital: 'resital',
        eighties: "80'ler" ,
        nineties: "90'lar" ,
        techno: 'tekno',
        //theatre
        theatre: 'Tiyatro',
        theaters: 'Tiyatro Oyunları',
        improvisation: 'doğaçlama',
        musical: 'müzikal',
        tragedy: 'trajedi',
        drama: "dram",
        comedy: "komedi",
        biography: "biyografi",
        privateTheatre: 'özel tiyatro',
        stateTheatre: 'devlet tiyatrosu',
        kidsTheatre: 'çocuk tiyatrosu',
        //sport
        sport: 'Spor',
        football: "football",
        basketball: "basketball",
        tennis: "tennis",
        volleyball: "volleyball",
        // atelier
        atelier: 'Atölye',
        ateliers: 'Atölyeler',
        painting: 'resim',
        dance: 'dans',
        cooking: 'aşçılık',
        sculpture: 'heykel',
        ceramic: 'seramik',
        yoga: 'yoga',
        seminar: 'seminer',
        mindfulness: 'mindfulness',
        science: 'bilim',
        personalDevelopment: 'kişisel gelişim',
        meditation: 'meditasyon',
        // exhibition
        exhibition: 'Sergi',
        exhibitions: 'Sergiler',
        digital: 'dijital',
        photo: 'fotoğraf',
        // festival
        festival: 'Festival',
        festivals: 'festivaller',
        art: 'sanat',
        coffee: 'kahve',
        music: 'müzik',
        film: 'film',
        foodAndDrink: 'yeme & içme',
        // stage
        stage: 'Sahne',
        stages: "Sahne Performansları",
        standUp: 'stand-up',
        show: 'gösteri',
        balletDance: 'bale-dans',
        opera: 'opera',
        // congress
        congress: 'Kongre',
        congresss: 'Kongreler',
         conference: 'konferans',
         symposium: 'sempozyum',
        // party
        party: 'Party',
        halloween: 'halloween',
    },
    dayNames: {
        1: 'Pazartesi',
        2: 'Salı',
        3: 'Çarşamba',
        4: 'Perşembe',
        5: 'Cuma',
        6: 'Cumartesi',
        0: 'Pazar'
    },
    monthNames: {
        0: "Ocak", 
        1: "Şubat", 
        2: "Mart", 
        3: "Nisan", 
        4: "Mayıs", 
        5: "Haziran", 
        6: "Temmuz", 
        7: "Ağustos", 
        8: "Eylül", 
        9: "Ekim", 
        10: "Kasım", 
        11: "Aralık"
    },
    profile: {
        personalInfo: 'Kişisel bilgi',
        accountSettings: 'Hesap ayarları'
    },
    auth: {
        logIn: 'Giriş yap',
        signUp: 'Kayıt ol',
        logOut: 'Çıkış yap',
        resetPassword: 'Şifre sıfırla',
        resetPasswordExplanation: 'Hesabınla ilişik olan olan e-posta adresini gir sana şifreni yenilemen için bir link postalayalım',
        sendResetLink: 'Yenileme linkini gönder',
        sendResetLinkSuccess: 'Şifre yenileme linki e-posta adresine gönderildi. Linke tıklayarak yeni bir şifre oluşturabilirsin',
        forgotPassword: 'Şifreni mi unuttun?',
        dontHaveAccount: '{msg} hesabın yok mu?',
        doYouHaveAccount: 'Hesabın var mı?',
        signInWithGoogle: 'Google ile giriş yap',
        signUpWithGoogle: 'Google ile hesap aç',
        signInWithFacebook: 'Facebook ile giriş yap',
        signUpWithFacebook: 'Facebook ile hesap aç',
        loginWithMail: 'E-posta ile giriş yap',
        signUpWithEmail: 'E-posta ile hesap aç',
        bySubmittingYouAccept: 'Bu formu onaylayarak ', // TODO
        email: 'E-posta',
        enterYourEmail: 'E-posta adresinizi girin',
        invalidEmail: 'Geçersiz e-posta adresi',
        password: 'Şifre',
        enterYourPassword: 'Şifrenizi girin',
        username: 'Kullanıcı adı',
        firstName: 'isim',
        lastName: 'soyisim',
        fullName: 'Ad Soyad', 
        phoneNumber: 'Telefon Numarası',
        invalidPhoneNumber: 'Geçersiz telefon numarası',
        enterYourUsername: 'Kullanıcı adınızı girin',
        rememberMe: 'Beni hatırla',
        createAccount: 'Hesap oluştur',
        showPassword: 'Şifreyi Göster',
        hidePassword: 'Şifreyi Gizle',
        createYourAccount: '{msg} hesabını oluştur',
        continueWithoutSignUp: 'Üye olmadan devam et',
        /* TODO revision */acceptSiteConditions: "Ön bilgilendirme formunu ve Mesafeli satış sözleşmesini okudum ve onaylıyorum.",
        /* TODO revision */acceptInfoAndCampaigns: "Tarafıma ticari bilgilendirme ve kampanya mesajlarının, elektronik ileti ve/veya SMS yoluyla yoluyla gönderilmesi için burada belirtilen iznim vardır.",
        createUserName: 'Kullanıcı adı belirle',
        createUserNameToUseInApplication: 'Uygulama içinde kullanmak için bir kullanıcı adı belirleyin',
        saveUsername: 'Kullanıcı adını kaydet',
        createAccountAndNeverMissAnEvent: '{msg} hasabı oluştur, şehrindeki hiçbir etkinliği kaçırma!',
        enterYourRealName: 'Biletlerde ve faturalarda kullanılmasını istediğiniz ad ve soyadı girin.'
    }
}

export default tr